module.exports = __webpack_public_path__ + "static/logo-arvato-0b822c24943af9be619ff651d84e80ec.svg";